/* Millesève — l'accroche de l'univers tient sur une ligne (E3.4, DS §4 « Retours à la ligne », v66).
   Sa taille est ajustée à la largeur de sa colonne : jamais plus que d1 (taille de la feuille de style),
   jamais moins de 28 px. Si elle ne tient pas à 28 px, elle reste en d1 et passe à la ligne.
   Recalculée au redimensionnement de la colonne, au chargement des polices et dans l'éditeur. */
(() => {
  const PLANCHER = 28;

  const ajuste = (h) => {
    h.style.fontSize = '';
    h.classList.remove('est-ajustee');
    const place = h.parentElement?.clientWidth;
    if (!place) return;
    h.style.whiteSpace = 'nowrap';
    const d1 = parseFloat(getComputedStyle(h).fontSize);
    const r = document.createRange();
    r.selectNodeContents(h);
    const largeur = r.getBoundingClientRect().width;
    h.style.whiteSpace = '';
    if (!largeur) return;
    const t = Math.floor(d1 * Math.min(1, place / largeur));
    if (t < PLANCHER) return;
    if (t < d1) h.style.fontSize = t + 'px';
    h.classList.add('est-ajustee');
  };

  const suivis = new WeakSet();
  const observe = new ResizeObserver((entrees) => {
    entrees.forEach((e) => {
      const h = e.target.querySelector(':scope > .ms-univers__accroche');
      if (h) ajuste(h);
    });
  });

  const lance = (racine = document) => {
    racine.querySelectorAll('.ms-univers__accroche').forEach((h) => {
      ajuste(h);
      const colonne = h.parentElement;
      if (colonne && !suivis.has(colonne)) {
        suivis.add(colonne);
        observe.observe(colonne);
      }
    });
  };

  lance();
  document.fonts?.ready.then(() => lance());
  document.addEventListener('shopify:section:load', (e) => lance(e.target));
})();
